<div class="step-container">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="step-nav-bar">
    @if (showSubmissionTypeConfigTab()) {
      <a id="submissionTypeConfig" routerLinkActive="active" [routerLink]="['submission-type-config']" [routerLinkActiveOptions]="{ exact: false }" queryParamsHandling="preserve" mat-tab-link>Submission Type Config</a>
    }
    <a id="fields" routerLinkActive="active" [routerLink]="['fields-container']" [queryParams]="{getMultiFields: false}" [routerLinkActiveOptions]="{ exact: false }" queryParamsHandling="merge" mat-tab-link>Fields</a>
    <a id="rules" routerLinkActive="active" [disabled]="!hasDrivingFields" [routerLink]="['rules-container']" [queryParams]="{getMultiFields: false}" [routerLinkActiveOptions]="{ exact: false }" queryParamsHandling="preserve" mat-tab-link>Rules</a>
    <a id="availability" routerLinkActive="active" [routerLink]="['availability-container']" [queryParams]="{getMultiFields: false}" [routerLinkActiveOptions]="{ exact: false }" queryParamsHandling="preserve"  mat-tab-link>Availability</a>
    @if (hasPrimaryFields) {
      <a id="primaryFieldConfig" routerLinkActive="active" [routerLink]="['primary-field-config']" queryParamsHandling="preserve" mat-tab-link>Primary Field</a>
    }
    <aw-route-filter [placeHolderText]="'Fields filter'" [filterName]="'fieldFilter'"></aw-route-filter>
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <div class="step-sub-view">
      <router-outlet></router-outlet>
    </div>
  </mat-tab-nav-panel>
</div>

